<template>
  <ul class="campaign-card-list">
    <CampaignCard
      v-for="(c, idx) in campaigns"
      :key="idx"
      :campaign="c"
      class="campaign-card"
    />
  </ul>
</template>

<script>
import CampaignCard from '@/components/CampaignCard';

export default {
  name: 'CampaignCardList',
  components: {
    CampaignCard,
  },
  props: {
    campaigns: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.campaign-card-list {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  > *:not(:first-of-type) {
    margin-left: 8px;
  }

  padding-bottom: 4px; // カードのシャドウが潰れるので
}

.campaign-card {
  flex: 0 0 auto;
  display: flex;

  width: 304px;
  @include mq(sm-and-down) {
    width: 100%;
    max-width: 304px;
  }

  max-height: 390.66px;
  @include mq(sm-and-down) {
    max-height: none;
  }
}
</style>
